// Shared UI type scale. Keep headings and supporting text distinct from body copy.
const typography = {
  family: "'Inter', 'Noto Sans Bengali', system-ui, -apple-system, 'Segoe UI', sans-serif",
  body: '14px',
  helper: '12px',
  section: '16px',
  page: '20px',
  lineHeight: 1.5,
};
export default typography;
